import RouteMap from "../RouteMap/RouteMap";
import { DRINK__ROUTES } from "../../routes/ROUTES";

export default function Bar() {
  return (
    <div className="container">
      <h1 className="routeMap__title">
        Що Ви бажаєте <br /> сьогодні <span>Замовити?</span>
      </h1>
      <p className="routeMap__text">Категорії:</p>
      <RouteMap items={DRINK__ROUTES} />
    </div>
  );
}
